import { getUnitsFromProperties } from 'accounts/utils/units';
import { useFullManagementHomes } from 'hooks/useFullManagementHomes';
import { STRINGS } from 'maintenance/strings';
import { PropertyType } from 'models/enums';

type MaintenanceCreateHome = {
  key: string;
  value: string;
  streetAddress: string;
};

export const useMaintenanceHomes = () => {
  const fullManagementHomes = useFullManagementHomes();
  const units = getUnitsFromProperties(fullManagementHomes);

  // `basicInfo`, `property.address` and `property.basicInfo` are all optional on
  // the generated models, but a full-management home always carries them and
  // every read below already dereferenced them unconditionally. The assertions
  // state that; they are erased at runtime, so a home missing one still throws
  // exactly where it did before.
  const homes = units
    .map((homeUnit) => {
      const formattedAddress = homeUnit.basicInfo!.unitNumber
        ? `${homeUnit.property.address!.streetAddress}, ${STRINGS.unit} ${homeUnit.basicInfo!.unitNumber}`
        : homeUnit.property.address!.streetAddress;

      return {
        key: homeUnit.basicInfo!.unitId,
        value: formattedAddress,
        streetAddress: homeUnit.property.address!.streetAddress,
      };
    })
    .sort((firstHome, secondHome) => {
      return firstHome.streetAddress!.localeCompare(
        secondHome.streetAddress!,
        undefined,
        {
          numeric: true,
          sensitivity: 'base',
        },
      );
    });

  const hasSingleHomeFamily = units?.some(
    (unit) =>
      unit?.property.basicInfo!.propertyType === PropertyType.SingleFamily,
  );

  return {
    homes: homes as MaintenanceCreateHome[],
    hasSingleHomeFamily,
  };
};
